<template>
  <div
    class="automaticActivation"
  >
    <div v-if="!disableDetail">
      <div class="btn">
        <el-form ref="searchForm" :model="searchForm" :inline="true" size="small">
          <el-form-item>
            <el-select v-model="searchForm.type" placeholder="选择" class="selectStyle" @change="changeType">
              <el-option label="批次" value="1" />
              <el-option label="SN号" value="2" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-if="searchForm.type=='1'" v-model.trim="searchForm.name" maxlength="50" clearable placeholder="输入批次名称" />
          </el-form-item>
          <el-form-item>
            <el-input v-if="searchForm.type=='2'" v-model.trim="searchForm.deviceNo" maxlength="50" clearable placeholder="输入设备SN号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleBtn('search')">
              查询
            </el-button>
            <el-button size="small" type="primary" @click="handleBtn('add')">
              新建
            </el-button>
          </el-form-item>
        </el-form>

      <!-- <el-button size="small" @click="handleBtn('import')" type="primary"> 批量导入</el-button> -->
      </div>
      <!-- <el-card>
      <el-form ref="searchForm" :model="searchForm" :rules="searchFormRules" :inline="true" size="small">
        <el-form-item prop="time" label="创建时间">
          <el-date-picker value-format="yyyy-MM-dd" v-model="searchForm.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @focus="dafaultVulue">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="deviceNo" label="设备SN号">
          <el-input maxlength="50" v-model="searchForm.deviceNo" clearable placeholder=""></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBtn('search')"> 查询</el-button>
          <el-button @click="handleBtn('reset')"> 重置</el-button>
        </el-form-item>
      </el-form>
    </el-card> -->
      <div>
        <el-table :data="dataList">
          <el-table-column type="index" width="55px" label="序号" />
          <el-table-column prop="name" label="批次名称" />
          <el-table-column prop="deviceQuantity" label="台数" />
          <el-table-column prop="remark" label="备注">
            <template slot-scope="scope">
              {{ scope.row.remark||'--' }}
            </template>
          </el-table-column>
          <el-table-column prop="createDate" label="创建时间" />
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="handleBtn('detail',scope.row)">
                查看详情
              </el-button>
              <el-button type="text" size="mini" @click="handleBtn('update',scope.row)">
                修改
              </el-button>
              <el-button type="text" size="mini" @click="deleteBatch(scope.row)">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total="pagination.total"
          :page.sync="pagination.pageNum"
          :limit.sync="pagination.pageSize"
          @handleSizeChange="getPageSize"
          @pagination="getPageSize"
        />
      </div>
    </div>
    <Detail v-if="disableDetail" :id="detailId" :visible.sync="disableDetail" />
    <el-dialog v-if="messageDialogVisible" width="600px" :close-on-click-modal="false" :visible.sync="messageDialogVisible" :title="handleType=='add'?'添加':'编辑'" @close="closeDialog">
      <el-form ref="editForm" :rules="rules" label-suffix="：" size="small" label-width="110px" :model="editForm">
        <el-form-item prop="name" label="批次名称">
          <el-input v-model="editForm.name" type="text" />
        </el-form-item>
        <el-form-item prop="remark" label="备注">
          <el-input v-model="editForm.remark" type="textarea" maxlength="100" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="closeDialog">
          取消
        </el-button>
        <el-button type="primary" size="medium" @click="handleAdd">
          确定
        </el-button>
      </div>
    </el-dialog>
    <!-- <el-dialog v-if="dialogUploadVisiblePackage" :close-on-click-modal="false" :visible.sync="dialogUploadVisiblePackage" @close="dialogClose" title="批量导入" width="540px">
      <el-form label-position="right" label-width="80px">
        <el-form-item prop="remark" label="备注">
          <el-input type="textarea" rows="4" v-model="uploadData.remark" maxlength="100" style=" margin-top: 20px"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style=" margin-bottom: 20px;vertical-align: top" icon="el-icon-upload2" size="medium" @click="handlerExcelTemplate">下载模板</el-button>
          <el-upload
            ref="upload"
            :on-success="onSuccess"
            :action="uploadUrl"
            :headers="uploadHeader"
            :before-upload="onBeforeUpload"
            :on-progress="onProgress"
            :on-error="onError"
            :multiple="false"
            :limit="1"
            :data="uploadData"
            name="file"
            accept=".xls, .xlsx"
            class="handle-btn"
          >
            <el-button :loading="fileUploading" size="medium" type="primary" icon="el-icon-upload2">{{ fileUploading?'上传文件中...':'上传文件' }}</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog> -->
    <!-- 批量导入异常 -->
    <!-- <el-dialog :close-on-click-modal="false" :visible.sync="dialogMultipleImportVisible" title="异常数据">
      <p style="padding:0 0 20px 20px;">导入失败，存在{{ abnormalDataList.length }}条异常记录，请修改后重新上传</p>
      <el-scrollbar wrap-class="abnormal-table">
        <el-table :data="abnormalDataList" fit highlight-current-row>
          <el-table-column type="index" width="55" align="center" label="序号" />
          <el-table-column label="异常原因" prop="errorMsg" align="center" >
            <template slot-scope="scope">
                <span style="color:red">{{scope.row.errorMsg}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-scrollbar>
    </el-dialog> -->
  </div>
</template>

<script>
import Detail from './detail';
import {
  getDeviceLotsList,
  // getMrdeskResourceList,
  createDeviceLotsInfo,
  updateDeviceLotsInfo,
  deleteDeviceLotsInfo,
  // getMrdeskResourceAdd,
  // getMrdeskResourceDefautImport,
  getMrdeskResourceDefautExport
} from '@/api/productOperation/financialCenter/mrdeskResource.js';
import { getDateTime } from '@/utils/index.js';
// import { getToken } from '@/utils/auth';
export default {
  name: 'MrdeskDevicManage',
  components: {
    Detail
  },
  data() {
    // SN号
    const validateRemark = (rule, value, callback) => {
      if (!value) callback();
      if (value.toString().length > 50) {
        callback(new Error('请输入50以内的字符'));
      } else {
        callback();
      }
    };
    // SN号
    // const validateDeviceSnAdd = (rule, value, callback) => {
    //   const pattern = new RegExp(/^[\d\s-_*]+$|^[A-Za-z\s\d-_*]+$/);
    //   if (!value) callback(new Error('课桌SN号不能为空'));
    //   if (!pattern.test(value)) {
    //     callback(new Error('请输入数字或字母字符'));
    //   } else if (value.toString().length > 20) {
    //     callback(new Error('请输入20以内的字符'));
    //   } else {
    //     callback();
    //   }
    // };
    // SN号
    // const validateDeviceSn = (rule, value, callback) => {
    //   if (!value) callback();
    //   const pattern = new RegExp(/^[\d\s-_*]+$|^[A-Za-z\s\d-_*]+$/);
    //   if (!pattern.test(value)) {
    //     callback(new Error('请输入数字或字母字符'));
    //   } else if (value.toString().length > 20) {
    //     callback(new Error('请输入20以内的字符'));
    //   } else {
    //     callback();
    //   }
    // };
    // 创建时间
    // const validateDatePicker = (rule, value, callback) => {
    //   if (!(value && value.length > 0)) callback();
    //   else if (value && value.length > 1 && value[0] && value[1]) {
    //     const end = new Date(value[1]);
    //     const start = new Date(value[0]);
    //     if ((end.getTime() - start.getTime()) > (3 * 30 * 24 * 60 * 60 * 1000 - 8.64e7)) {
    //       callback(new Error('请选择90天内的数据'));
    //     } else {
    //       callback();
    //     }
    //   }
    // };
    return {
      dialogMultipleImportVisible: false,
      dialogUploadVisiblePackage: false,
      abnormalDataList: [],
      // fileUploading: false, // 文件上传加载
      // uploadUrl: '', // 上传文件URL
      // uploadHeader: {
      // }, // 上传文件上传头
      // uploadData: {
      //   remark: ''
      // },
      messageDialogVisible: false,
      editForm: { name: null, remark: null },
      dataList: [],
      searchForm: {
        type: '1',
        name: '',
        deviceNo: ''
      },
      // searchForm: {
      //   time: [],
      //   deviceNo: null,
      //   endCreateDate: null,
      //   startCreateDate: null
      // },
      pagination: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      detailId: '',
      rules: {
        name: [{ required: true, message: '批次名称不能为空', trigger: 'blur' }],
        remark: [{ validator: validateRemark, trigger: 'blur' }]
      },
      disableDetail: false,
      handleType: 'add',
      option: {}
    };
  },
  mounted() {
    this.getData();
    // this.initUploadData();
  },
  methods: {
    changeType(e) {
      if (e === '1') {
        this.searchForm.deviceNo = null;
      } else {
        this.searchForm.name = null;
      }
    },
    deleteBatch(row) {
      this.$confirm(`确定要删除该批次么?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        return deleteDeviceLotsInfo(row.id);
      }).then(res => {
        this.$notify.success({ title: 'Success', message: '删除成功', showClose: false, duration: 2000 });
        this.getData();
      }).catch(() => {});
    },
    dafaultVulue() {
      this.searchForm.time = [getDateTime(0), getDateTime(0)];
    },
    // 初始化上传数据
    // initUploadData() {
    //   const accessToken = getToken();
    //   this.uploadHeader = {
    //     Authorization: `Bearer ${accessToken}`
    //   };
    //   this.uploadUrl = getMrdeskResourceDefautImport(); // 导入
    // },
    closeDialog() {
      this.editForm = this.$options.data().editForm;
      this.$refs.editForm.resetFields();
      this.messageDialogVisible = false;
    },
    handleAdd() {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          if (this.handleType === 'add') {
            createDeviceLotsInfo(this.editForm).then((res) => {
              if (res.code === '0') {
                this.closeDialog();
                this.$message.success('操作成功');
                this.getData();
              }
            });
          } else {
            updateDeviceLotsInfo(this.editForm.id, this.editForm).then((res) => {
              if (res.code === '0') {
                this.closeDialog();
                this.$message.success('操作成功');
                this.getData();
              }
            });
          }
        }
      });
    },
    handleBtn(e, row) {
      if (e === 'detail') {
        this.detailId = row.id;
        this.disableDetail = true;
      } else if (e === 'add') {
        this.handleType = 'add';
        this.messageDialogVisible = true;
      } else if (e === 'update') {
        this.editForm = { name: row.name, remark: row.remark, id: row.id };
        this.handleType = 'update';
        this.messageDialogVisible = true;
      } else if (e === 'import') {
        this.dialogUploadVisiblePackage = true;
      } else if (e === 'search') {
        this.pagination.pageNum = 1;
        this.pagination.pageSize = 10;
        this.option = {
          name: this.searchForm.name,
          deviceNo: this.searchForm.deviceNo
        };
        this.getData();
        // if (this.searchForm.time !== null) {
        //   this.searchForm.startCreateDate = this.searchForm.time[0] || null;
        //   this.searchForm.endCreateDate = this.searchForm.time[1] || null;
        // } else {
        //   this.searchForm.startCreateDate = null;
        //   this.searchForm.endCreateDate = null;
        // }
        // this.pagination.pageNum = 1;
        // this.$refs['searchForm'].validate((valid) => {
        //   if (valid) {
        //     this.getData();
        //   }
        // });
      }
    },
    getPageSize({ page, limit }) {
      this.pagination.pageNum = page;
      this.pagination.pageSize = limit;
      this.getData();
    },
    getData() {
      getDeviceLotsList({
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.pageNum,
        ...this.option
      }).then((res) => {
        this.dataList = res.data.list;
        this.pagination.total = res.data.total;
      });
    },
    handlerExcelTemplate() {
      window.location.href = getMrdeskResourceDefautExport();
    }
    // onBeforeUpload() {
    //   if (this.uploadData.remark && this.uploadData.remark.toString().length > 50) {
    //     this.$message({
    //       message: '请输入50以内的字符',
    //       type: 'error'
    //     });
    //     return false;
    //   }
    // },
    // 导入 加载
    // onProgress() {
    //   this.fileUploading = true;
    // },
    // onError() {
    //   this.fileUploading = false;
    //   this.$message({
    //     message: '文件上传失败',
    //     type: 'error'
    //   });
    // },

    // 导入上传成功
    // onSuccess(response, file, fileList) {
    //   this.fileUploading = false;
    //   this.$refs.upload.clearFiles();
    //   if (response.code === '0') {
    //     this.$message({
    //       message: '文件上传成功',
    //       type: 'success'
    //     });
    //     this.getData();
    //     this.dialogUploadVisiblePackage = false;
    //   } else {
    //     if (response.data) {
    //       this.dialogMultipleImportVisible = true;
    //       this.abnormalDataList = [];
    //       const list = response.data;
    //       list.forEach(v => {
    //         this.abnormalDataList.push({ errorMsg: v });
    //       });
    //     } else {
    //       this.$message({
    //         message: response.message,
    //         type: 'error'
    //       });
    //       this.abnormalDataList = [];
    //     }
    //   }
    // },
    // dialogClose() {
    //   this.uploadData.remark = '';
    //   this.dialogUploadVisiblePackage = false;
    // }
  }
};
</script>

<style lang="scss" scoped>
.automaticActivation {
  .btn {
    margin: 10px 0;
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
    .selectStyle{
      width: 120px;
      margin-left: 20px;
    }
  }
  .handle-btn{
    display: inline-block;
    margin-left: 20px;
  }
}
</style>
